import type { OrganSupportDTO } from '@/generated'
import { translateOrganSupportDTO } from '@/util/translations'

export function parseOrganSupportDTO(
  organSupport: OrganSupportDTO,
  translateFunction: (key: string) => string
): string[] {
  const list: string[] = []
  Object.entries(organSupport).forEach(([organSupportType, exist]) => {
    if (exist) {
      list.push(
        translateOrganSupportDTO(organSupportType as keyof OrganSupportDTO, translateFunction)
      )
    }
  })

  return list
}
